<template>
    <div>
        <div class="order-userInfo">
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>基本设置</h5>
                    <el-row class="userInfo-group">
                        <el-row>
                            <el-col :span="8" class="order-item">
                                学校域名：<span>{{ product.content.init.cor_domain_url}}</span></el-col>
                            <el-col :span="8" class="order-item">合作机构名称：<span>{{product.content.init.cor_name}}</span>
                            </el-col>
                            <el-col :span="8" class="order-item">服务时间：<span>{{new Date(product.content.start_at).toLocaleDateString()}}-{{new Date(product.content.end_at).toLocaleDateString()}}</span>
                            </el-col>
                        </el-row>
                    </el-row>
                </div>
            </div>
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>额度设置</h5>
                    <div class="userInfo-group">
                        <div class="set-wrapper">
                            <el-row class="set-number">
                                <el-col :span="8" class="order-item">
                                    试题篮数量设置：<span>{{product.content.limit_configure.question_num}}</span>
                                    <span v-html="showOldConfigOther('limit_configure','question_num')"></span>
                                </el-col>
                                <el-col :span="8" class="order-item">
                                    试题日下载次数：<span>{{product.content.limit_configure.paper_download}}</span>
                                    <span v-html="showOldConfigOther('limit_configure','paper_download')"></span>
                                </el-col>
                            </el-row>
                        </div>
                        <el-table
                                :data="product.content.limit_configure.batch"
                                border
                                style="width: 100%">
                            <el-table-column prop="subject_name" label="所有科目">
                            </el-table-column>
                            <el-table-column prop="config.primary" label="小学">
                                <template slot-scope="scope">
                                    {{scope.row.config.primary}}
                                    <span v-html="showOldConfig(scope.row.subject_id,'primary')"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config.middle" label="初中">
                                <template slot-scope="scope">
                                    {{scope.row.config.middle}}
                                    <span v-html="showOldConfig(scope.row.subject_id,'middle')"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config.high" label="高中">
                                <template slot-scope="scope">
                                    {{scope.row.config.high}}
                                    <span v-html="showOldConfig(scope.row.subject_id,'high')"></span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CustomerService from "~/services/customer";
    export default {
        data() {
            return {
                batch: [],
                oldConfig:{}
            }
        },
        props: {
            product: {
                type: Object
            }
        },
        created() {
            let subject_config = Object.assign({}, this.product.content.limit_configure.batch);
            this.batch = Object.keys(subject_config).map(key => subject_config[key]);
            this.batch = this.batch.filter(item => {
                return item.subject_id > 0;
            })
            this.getOrder()
        },
        methods: {
            getOrder() {
                CustomerService.product_config({product_code:this.product.product_code,customer_id:this.product.customer_id}).then(res => {
                    this.oldConfig = res.data;
                })
            },
            showOldConfig(subject_id,type){
                if(typeof this.oldConfig.limit_configure != 'undefined' && typeof this.oldConfig.limit_configure.batch != 'undefined'){
                    let item = this.oldConfig.limit_configure.batch.find(i=>{return i.subject_id == subject_id });
                    let oldItem = this.product.content.limit_configure.batch.find(i=>{return i.subject_id == subject_id });
                    if(!item) return "";
                    if(oldItem.config[type] == item.config[type]) return "";
                    return "<span  style='color: #f5222d'>原来:"+item.config[type]+"</span>";
                }
                return "";
            },
            showOldConfigOther(type,need)
            {
                if(typeof this.oldConfig[type] !='undefined'){
                    if(this.product.content[type][need]==this.oldConfig[type][need]) return "";
                    return "<span  style='color: #f5222d'>原来:"+this.oldConfig[type][need]+"</span>";
                }
                return "";
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/views/order/products/zj-cooperate.vue